import { Button, Modal } from "antd"
import { IClose } from "icons/IClose"
import React, { Dispatch, SetStateAction } from "react"
import constant from "constant/action"
import axios from "config/axios"
import { toast } from "utils/notification"
import { setIsLoading } from "store/duck/common";
import { useDispatch } from "react-redux"
import "./style.scss"

interface Props {
  open: boolean
  setOpen: Dispatch<SetStateAction<boolean>>
  resetType: string
  resetTypeLabel: string
}

interface ResetDataParams {
  reset_type: string
}

const ResetConfirmModal: React.FC<Props> = ({
  open,
  setOpen,
  resetType,
  resetTypeLabel,
}) => {
  const dispatch = useDispatch()

  const handleResetConfirm = async () => {
    try {
      console.log('handleResetConfirm')
      const data: ResetDataParams = {
        reset_type: resetType,
      }
      const url = constant.RESET_DATA
      dispatch(setIsLoading(true))
      await axios.delete(url, { data })
      dispatch(setIsLoading(false))
      toast("success", "リセットが完了しました")
    } catch (error: any) {
      dispatch(setIsLoading(false))
      if (error && error.response) {
        const errorMessage = error.response?.data?.error
        toast("error", errorMessage)
      }
    }
  }

  return (
    <Modal
      centered
      open={open}
      footer={null}
      closeIcon={null}
      className="resetConfirmModalContainer"
      getContainer={() => document.getElementById("canvas-root")!}
    >
      <div
        className="flex justify-end cursor-pointer"
        onClick={() => {
          setOpen(false)
        }}
      >
        <IClose />
      </div>
      <div className="flex flex-col items-center px-[20px] pt-[20px] pb-[42px]">
        <p className="font-noto-sans text-[20px] not-italic font-bold text-[#7b7b7b] pb-[20px]">
          {resetTypeLabel !== '全て' ? `${resetTypeLabel}と関連データを` : ''}全てリセットしますか？
        </p>
        <div className="flex justify-center">
          <Button
            className="button-reset mt-[40px]"
            onClick={() => {
              handleResetConfirm()
              setOpen(false)
            }}
          >
            リセット
          </Button>
        </div>
      </div>
    </Modal>
  )
}

export default ResetConfirmModal
